import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl, api_service_path } from "./utils"

export const validatePassAction = createApi({
    reducerPath: "checkPass",
    baseQuery: fetchBaseQuery({
        baseUrl: `${baseUrl}/${api_service_path.checkPass}`
    }),
    tagTypes: ["check_pass"],
    endpoints: (builder) => ({
        checkAdmitCardPass: builder.mutation({
            query: ({
                school_id,
                class_id,
                roll_no,
                dob,
                exam
            }) => ({
                url: "/admit",
                method: "POST",
                body: {
                    school_id,
                    class_id,
                    roll_no,
                    dob,
                    exam
                }
            })
        })
    })
})

export const {
    useCheckAdmitCardPassMutation
} = validatePassAction